<div *ngIf="loading" class="row">
	<div align="center" class="col-md-12">
		<br />
		<div class="loader"></div>
	</div>
</div>
@if(!loading){
<div
	class="page-wrapper"
	appScrollListener
	(scrolled)="onContainerScroll($event)"
	#scrollableContainer="appScrollListener"
>
	@if(toTopButtonVisible){
	<a class="scroll-up-button" (click)="scrollToTop(scrollableContainer)" aria-label="To top" title="Go to top">
		<i class="fa fa-arrow-up" aria-hidden="true"></i>
	</a>
	}
	<div class="top-search-and-sync">
		<input
			#name
			(input)="searchTrigger$.next()"
			[(ngModel)]="searchKeyword"
			type="text"
			class="form-control search-input"
			placeholder="{{ searchPlaceholder }}"
		/>
		<!-- <div style="height: 19px; line-height: 0px;">
		<input id="autoReceiveApply" type="checkbox" [(ngModel)]="settings.AutoReceiveApply" (ngModelChange)="updateCheckbox()"/>
		<label for="autoReceiveApply" class="ml-5">AutoReceiveApply</label>
	  </div> -->
		<div class="input-checkbox-wrapper">
			<input
				id="autoTransferApply"
				type="checkbox"
				[(ngModel)]="settings.AutoTransferApply"
				(ngModelChange)="updateCheckbox()"
			/>
			<label for="autoTransferApply">Auto apply</label>
		</div>
		<button
			class="btn btn-info button-refresh copyAndRefreshButton simpleRfIdColor cursorFinger"
			(click)="refresh()"
			title="Refresh"
		>
			<span class="fa fa-sync-alt button-icon"></span>
		</button>
	</div>
	<div class="table-wrapper">
		<div class="table-scroller">
			@if(loadingInBody){
			<div *ngIf="loadingInBody" align="center">
				<br />
				<div class="loader"></div>
			</div>
			} @else {
			<table class="table">
				<tbody>
					@for(operation of historyItems; track operation){

					<tr class="auto-sync-table-bordered no-hover">
						<td>
							<div class="row-description">
								<b class="mr-4">{{ operation.Type }}</b>
								{{ operation.CreateDate | localDate }}

								@if(hasWaitingAdjustments(operation)){
								<button
									type="submit"
									style="width: 70px"
									class="btn btn-info btn-sm"
									(click)="syncAll(operation)"
								>
									Sync All
								</button>
								}
							</div>
							<table>
								<thead>
									<tr class="table-header">
										<th class="col-img"></th>
										<th class="col-title">Product Title</th>
										<th class="col-location">Location</th>
										<th class="col-adjustment text-center">Adjustment</th>
										<th class="col-shopify-inventory text-center">Shopify Inventory</th>
										<th class="col-status text-center">Status</th>
										<th class="col-action"></th>
									</tr>
								</thead>
								<tbody>
									<ng-container
										*ngFor="
											let item of operation.ShopifyInventoryAdjustments;
											let i = index;
											let last = last
										"
									>
										<tr class="destination-details no-hover" [ngClass]="{ 'last-item': last }">
											<td
												[attr.rowspan]="
													operation.Type === 'Purchase'
														? 1
														: item.ShopifyOriginInventoryAdjustments.length + 1
												"
											>
												<div class="table-img-box">
													<app-image-handler [product]="item"></app-image-handler>
												</div>
											</td>
											<td
												[attr.rowspan]="
													operation.Type === 'Purchase'
														? 1
														: item.ShopifyOriginInventoryAdjustments.length + 1
												"
											>
												{{ item.ProductTitle }}
											</td>
											<td>Destination: {{ item.LocationName }}</td>
											<td class="text-center">+{{ item.Adjustment }}</td>
											<td class="text-center">{{ item.NewOnHandQuantity }}</td>
											<td
												[attr.rowspan]="
													operation.Type === 'Purchase'
														? 1
														: item.ShopifyOriginInventoryAdjustments.length + 1
												"
												class="text-center"
											>
												{{ item.Status }}
											</td>
											<td
												[attr.rowspan]="
													operation.Type === 'Purchase'
														? 1
														: item.ShopifyOriginInventoryAdjustments.length + 1
												"
												class="text-end"
											>
												@if(item.Status == autoSyncOperationStatusEnum.Waiting){
												<button
													type="submit"
													style="width: 50px"
													class="btn btn-info btn-sm"
													(click)="sync(item)"
												>
													Sync
												</button>
												}
											</td>
										</tr>
										<tr
											class="origin-details no-hover"
											*ngFor="let origin of item.ShopifyOriginInventoryAdjustments"
										>
											<td>Origin: {{ origin.LocationName }}</td>
											<td class="text-center">{{ origin.Adjustment }}</td>
											<td class="text-center">
												{{ origin.NewOnHandQuantity }}
											</td>
										</tr>
										<tr *ngIf="!last" class="delimiter">
											<td colspan="10"></td>
										</tr>
										<!-- <ng-container *ngFor="let detail of operation?.Details let ind = index">
						  <tr>
							<td></td>
							<td style="text-align: end;">{{ind + 1}}.</td>
							<td>{{detail.LocationName}} </td>
							<td style="text-align: center;">{{detail.Adjustment}} </td>
							<td style="text-align: center;">{{detail.NewOnHandQuantity}} </td>
							<td></td>
							<td></td>
						  </tr>
						</ng-container> -->
									</ng-container>
								</tbody>
							</table>
						</td>
					</tr>
					}
				</tbody>
			</table>
			}
		</div>
	</div>

	<div class="pager-container">
		<nav>
			<ul class="pagination justify-content-center">
				<li class="page-item cursorFinger" [ngClass]="{ disabled: shopifyPage === 1 }">
					<a class="page-link colorGray" (click)="getHistory(shopifyPage - 1)"
						><span class="fa fa-angle-left"></span
					></a>
				</li>
				<li class="page-item">
					<a class="page-link">{{ shopifyPage }}</a>
				</li>
				<li class="page-item cursorFinger" [ngClass]="{ disabled: pageButtonBlock }">
					<a class="page-link colorGray" (click)="getHistory(shopifyPage + 1)"
						><span class="fa fa-angle-right"></span
					></a>
				</li>
			</ul>
		</nav>
	</div>
</div>
}
